interface ApplicationChild {
	applicationChildId: Number;
	applicationId: Number;
	customerId: Number;
	name: string;
	ssn: string;
	birthDate: string;
	customerResponsibility: 0 | 1 | 2;
}

// Reflect logic in ChildListSection.tsx
const getAge = (birthday: string): number => {
	const birthDate = new Date(birthday);
	const today = new Date();
	let age = today.getFullYear() - birthDate.getFullYear();
	const monthsDiff = today.getMonth() - birthDate.getMonth();
	if (
		monthsDiff < 0 || // Birth-month is a later month than today
		(monthsDiff === 0 && today.getDate() < birthDate.getDate()) // Birth-month is this month, but birth-date is not "here" yet
	)
		age -= 1;
	return age;
};

export function CalculateAgeFromBirthday(
	children: ApplicationChild[] = []
): string[] {
	return (
		children
			//.filter(x => getAge(x.birthDate) < 18)
			.map(x => `${getAge(x.birthDate)}`)
	);
}
